import { ApolloError } from '@apollo/client/errors';

export default function getDescriptionFromError(
  error: ApolloError | null | undefined,
): string {
  if (!error) return '';
  const graphQLErrors = error.graphQLErrors || [];
  const messages = graphQLErrors.map(({ message }) => message);
  if (messages.length === 0) {
    return error.message;
  }
  return Array.from(new Set(messages)).join('\n');
}
